import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
  FormControl,
  Typography,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { eventService } from "../../utils/services/eventService";
import DownloadIcon from "../../globalStyles/icons/download-icon";
import { manifestService } from "../../utils/services/manifestService";
import FileSaver from "file-saver";

const ManifestDownloadModal = ({ open, handleClose, selectedManifest }) => {
  const initialData = {
    hawb_prefix: "",
    hawb_suffix: "",
    airline: "",
    mawb_no: "",
    sender_name: "",
    sender_orgname: "",
    sender_address1: "",
    sender_address2: "",
    sender_district: "",
    sender_city: "",
    sender_state: "",
    sender_zip5: "",
    sender_zip4: "",
    sender_country: "",
    sender_phone: "",
    sender_email: "",
    sender_url: "",
    sort_code: "",
  };
  const [manifestData, setManifestData] = useState(initialData);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [manifestConfig, setManifestConfig] = useState(null);

  useEffect(() => {
    if (manifestConfig && manifestConfig !== undefined) {
      setManifestData(manifestConfig);
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  }, [manifestConfig]);

  useEffect(() => {
    if (selectedManifest && open) {
      fetchManifestConfig();
    }
  }, [selectedManifest, open]);

  const fetchManifestConfig = async () => {
    try {
      const response = await manifestService.fetchManifestConfig(
        selectedManifest?.manifest?.id || "",
      );
      if (response.data?.length) {
        setManifestConfig(response?.data[0]);
      } else {
        fetchConsignoreDetails();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchConsignoreDetails = async () => {
    try {
      const response = await manifestService.fetchConsignorDetails(
        selectedManifest?.manifest?.id || "",
      );
      setManifestData({
        ...manifestData,
        sender_name: response?.consignor_name,
        sender_address1: response?.address1,
        sender_address2: response?.address2,
        sender_district: response?.city,
        sender_city: response?.city,
        sender_state: response?.province,
        sender_zip5: response?.postal,
        sender_country: response?.country,
        sender_phone: response?.contact_number,
        sender_email: response?.email,
      });
    } catch (error) {
      toast.error(error);
    }
  };
  const validateForm = () => {
    const errors = {};
    if (!manifestData.hawb_prefix) {
      errors.hawb_prefix = "Hawb prefix is required";
      return false;
    }
    if (!manifestData.hawb_suffix) {
      errors.hawb_suffix = "Hawb suffix is required";
      return false;
    }
    if (!manifestData.sender_name) {
      errors.sender_name = "Sender Name is required";
      return false;
    }
    if (!manifestData.sender_orgname) {
      errors.sender_orgname = "Sender org name is required";
      return false;
    }
    if (!manifestData.sender_address1) {
      errors.sender_address1 = "Sender address1 is required";
      return false;
    }
    if (!manifestData.sender_district) {
      errors.sender_district = "Sender district is required";
      return false;
    }
    if (!manifestData.sender_city) {
      errors.sender_city = "Sender city is required";
      return false;
    }
    if (!manifestData.sender_state) {
      errors.sender_state = "Sender state is required";
      return false;
    }
    if (!manifestData.sender_zip5) {
      errors.sender_zip5 = "Sender zip5 is required";
      return false;
    }

    if (!manifestData.sender_state) {
      errors.sender_state = "Sender state is required";
      return false;
    }
    if (!manifestData.sender_country) {
      errors.sender_country = "Sender country is required";
      return false;
    }
    if (!manifestData.sender_phone) {
      errors.sender_phone = "Sender phone is required";
      return false;
    }
    if (!manifestData.sender_email) {
      errors.sender_email = "Sender email is required";
      return false;
    }

    if (!manifestData.sort_code) {
      errors.sort_code = "Sort code is required";
      return false;
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  useEffect(() => {
    setValidated(validateForm());
  }, [manifestData]);
  const handleDownload = async () => {
    try {
      const response = await manifestService.packingList({
        manifest: selectedManifest.manifest.id.toString(),
        hawb_prefix: manifestData.hawb_prefix,
        hawb_suffix: manifestData.hawb_suffix,
        sort_code: manifestData.sort_code,
        mawb_no: manifestData.mawb_no,
      });
      let sliceSize = 1024;
      let byteCharacters = atob(response.file);
      let bytesLength = byteCharacters.length;
      let slicesCount = Math.ceil(bytesLength / sliceSize);
      let byteArrays = new Array(slicesCount);
      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);
        let bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      let blob = new Blob(byteArrays, { type: response.contentType });
      FileSaver.saveAs(new Blob([blob], {}), response.filename);
      // handleDownload(response)

      // Assuming 'response' contains an array of objects
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("Fetch error:", error);
      }
    }
  };
  const handleDownloadManifest = async () => {
    if (!validateForm()) return;
    try {
      const response = await manifestService.manifestDocument({
        ...manifestData,
        manifest: selectedManifest.manifest.id.toString(),
      });
      let sliceSize = 1024;
      let byteCharacters = atob(response.file);
      let bytesLength = byteCharacters.length;
      let slicesCount = Math.ceil(bytesLength / sliceSize);
      let byteArrays = new Array(slicesCount);
      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);
        let bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      let blob = new Blob(byteArrays, { type: response.contentType });
      FileSaver.saveAs(new Blob([blob], {}), response.filename);
      // handleDownload(response)

      // Assuming 'response' contains an array of objects
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("Fetch error:", error);
      }
    }
  };
  const handleCreateManifestConfig = () => {
    try {
      if (!validateForm()) return;
      if (manifestConfig && manifestConfig !== undefined) {
        manifestService.updateManifestConfig(manifestConfig?._id, {
          ...manifestData,
          manifest: selectedManifest.manifest.id.toString(),
        });
        toast.success("Manifest Config Updated Successfully");
        setShowButton(true);
        return;
      } else {
        const response = manifestService.createManifestConfig({
          ...manifestData,
          manifest: selectedManifest.manifest.id.toString(),
        });
        toast.success("Manifest Config Created Successfully");
        setShowButton(true);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        setManifestData(initialData);
        setShowButton(false);
      }}
      maxWidth="md"
      aria-labelledby="form-dialog-title"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle
          id="form-dialog-title"
          style={{
            fontFamily: "Poppins",
            fontSize: 24,
            fontWeight: 500,
            color: "var(--text-primary)",
          }}
        >
          {`Download Manifest Document : ${selectedManifest?.manifest?.id}`}
        </DialogTitle>
        <IconButton
          onClick={() => {
            setManifestData(initialData);
            handleClose();
            setShowButton(false);
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <Divider style={{ marginBottom: 10 }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              HAWB Prefix <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="hawb_prefix"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.hawb_prefix}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  hawb_prefix: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.hawb_prefix}
              disabled={showButton}
            />
            {!!formErrors.hawb_prefix && (
              <FormHelperText error>{formErrors.hawb_prefix}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              HAWB Suffix <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="hawb_suffix"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.hawb_suffix}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  hawb_suffix: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.hawb_suffix}
              disabled={showButton}
            />
            {!!formErrors.hawb_suffix && (
              <FormHelperText error>{formErrors.hawb_suffix}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Airline
            </CustomTypography>
            <TextField
              name="airline"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.airline}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  airline: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              disabled={showButton}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              MAWB No
            </CustomTypography>
            <TextField
              name="mawb_no"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.mawb_no}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  mawb_no: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.mawb_no}
              disabled={showButton}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Name <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_name"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_name}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_name: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_name}
              disabled={showButton}
            />
            {!!formErrors.sender_name && (
              <FormHelperText error>{formErrors.sender_name}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Orgname <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_orgname"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_orgname}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_orgname: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_orgname}
              disabled={showButton}
            />
            {!!formErrors.sender_orgname && (
              <FormHelperText error>{formErrors.sender_orgname}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Address1 <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_address1"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_address1}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_address1: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_address1}
              disabled={showButton}
            />
            {!!formErrors.sender_address1 && (
              <FormHelperText error>
                {formErrors.sender_address1}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Address2
            </CustomTypography>
            <TextField
              name="sender_address2"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_address2}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_address2: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_address2}
              disabled={showButton}
            />
            {!!formErrors.sender_address2 && (
              <FormHelperText error>
                {formErrors.sender_address2}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender District <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_district"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_district}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_district: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_district}
              disabled={showButton}
            />
            {!!formErrors.sender_district && (
              <FormHelperText error>
                {formErrors.sender_district}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender City <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_city"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_city}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_city: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_city}
              disabled={showButton}
            />
            {!!formErrors.sender_city && (
              <FormHelperText error>{formErrors.sender_city}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender State <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_state"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_state}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_state: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_state}
              disabled={showButton}
            />
            {!!formErrors.sender_state && (
              <FormHelperText error>{formErrors.sender_state}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Zip5 <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_zip5"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_zip5}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_zip5: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_zip5}
              disabled={showButton}
            />
            {!!formErrors.sender_zip5 && (
              <FormHelperText error>{formErrors.sender_zip5}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Zip4
            </CustomTypography>
            <TextField
              name="description"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_zip4}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_zip4: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_zip4}
              disabled={showButton}
            />
          </Grid>{" "}
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Country <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_country"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_country}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_country: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_country}
              disabled={showButton}
            />
            {!!formErrors.sender_country && (
              <FormHelperText error>{formErrors.sender_country}</FormHelperText>
            )}
          </Grid>{" "}
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Phone <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_phone"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_phone}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_phone: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_phone}
              disabled={showButton}
            />
            {!!formErrors.sender_phone && (
              <FormHelperText error>{formErrors.sender_phone}</FormHelperText>
            )}
          </Grid>{" "}
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender Email <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sender_email"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_email}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_email: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_email}
              disabled={showButton}
            />
            {!!formErrors.sender_email && (
              <FormHelperText error>{formErrors.sender_email}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sender URL
            </CustomTypography>
            <TextField
              name="sender_url"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sender_url}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sender_url: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sender_url}
              disabled={showButton}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              style={{
                fontSize: 14,
                fontFamily: "Poppins",
                fontWeight: 400,
                color: "var(--text-heading)",
              }}
            >
              Sort Code <span style={{ color: "red" }}>*</span>
            </CustomTypography>
            <TextField
              name="sort_code"
              type="text"
              style={{ backgroundColor: "var(--bg-paper)" }}
              size="small"
              value={manifestData.sort_code}
              onChange={(e) =>
                setManifestData({
                  ...manifestData,
                  sort_code: e.target.value,
                })
              }
              fullWidth
              margin="dense"
              error={!!formErrors.sort_code}
              disabled={showButton}
            />
            {!!formErrors.sort_code && (
              <FormHelperText error>{formErrors.sort_code}</FormHelperText>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          paddingBottom: 15,
          paddingRight: 15,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {manifestConfig !== undefined && showButton ? (
            <Button
              style={{
                textTransform: "none",
                marginLeft: 3,
              }}
              variant="contained"
              color="primary"
              onClick={() => {
                setShowButton(false);
              }}
            >
              <Typography
                sx={{ color: "#FFF" }}
                fontSize="14px"
                fontWeight={500}
                fontFamily={"poppins"}
              >
                Edit
              </Typography>
            </Button>
          ) : (
            <></>
          )}
        </div>
        <div>
          {" "}
          <Button
            // size="small"
            style={{
              textTransform: "none",
              marginRight: 3,
            }}
            variant="outlined"
            color="primary"
            onClick={() => {
              handleClose();
              setManifestData(initialData);
              setShowButton(false);
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight={500}
              color={"primary"}
              fontFamily={"poppins"}
            >
              Cancel
            </Typography>
          </Button>
          {!showButton && (
            <Button
              size="small"
              style={{
                textTransform: "none",
              }}
              variant="contained"
              color="primary"
              onClick={() => handleCreateManifestConfig()}
              disabled={!validated}
            >
              <Typography
                fontSize="14px"
                fontWeight={500}
                color={"#ffff"}
                fontFamily={"poppins"}
              >
                Ok
              </Typography>
            </Button>
          )}
          {showButton && (
            <>
              <Button
                size="small"
                style={{
                  textTransform: "none",
                  marginRight: 3,
                }}
                variant="contained"
                color="primary"
                onClick={() => handleDownloadManifest()}
              >
                <DownloadIcon fill={"#ffff"} />
                <Typography
                  fontSize="14px"
                  fontWeight={500}
                  sx={{
                    color: "#ffff",
                    marginLeft: 1,
                  }}
                  fontFamily={"poppins"}
                >
                  Manifest Document
                </Typography>
              </Button>
              <Button
                size="small"
                style={{
                  textTransform: "none",
                }}
                variant="contained"
                color="primary"
                onClick={() => handleDownload()}
              >
                <DownloadIcon fill={"#ffff"} />
                <Typography
                  fontSize="14px"
                  fontWeight={500}
                  sx={{
                    color: "#ffff",
                    marginLeft: 1,
                  }}
                  fontFamily={"poppins"}
                >
                  PackingList
                </Typography>
              </Button>
            </>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ManifestDownloadModal;
